import React from 'react';

export const SessionExpired = () => <span id='oidcProvider_sessionLostComponent'></span>;
